// @ts-nocheck
import { formattedAmount } from '@/utils';
import { getDecorationExtSellValue } from '@/utils/decorationTotals';

export const buildLineItemsPayload = (variants) => {
  return variants.map(row => {
    const cost = parseFloat(row.cost || 0);
    const price = parseFloat(row.price || 0);
    const quantity = row.quantity ? Number(row.quantity) : 1;
    const skuId =
    row.skuId !== undefined &&
    row.skuId !== null &&
    `${row.skuId}` !== ''
      ? row.skuId
      : row.sku_id !== undefined &&
        row.sku_id !== null &&
        `${row.sku_id}` !== ''
      ? row.sku_id
      : null;
    const reservedKeys = new Set(['id', 'tempId', 'quantity', 'cost', 'price', 'margin', 'extSell', 'imageUrl', 'skuLabel', 'skuId', 'description', 'vendorSku']);
    const variantObj = Object.fromEntries(
      Object.entries(row).filter(([k, v]) => !reservedKeys.has(k) && v !== null && v !== undefined && v !== '')
    );
    const skuLabel = Object.values(variantObj)
      .map((v) => {
        if (v === null || v === undefined) return '';
        if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') return `${v}`;
        if (typeof v === 'object') return v?.name ?? v?.label ?? v?.value ?? '';
        return '';
      })
      .filter(Boolean)
      .join('/');
    return {
      ...(row.id ? { id: row.id } : {}),
      skuId,
      variant: variantObj,
      quantity: quantity,
      cost,
      price,
      imageUrl: row.imageUrl || '',
      skuLabel,
      description: row.description || '',
      extSell: price * quantity,
      margin: cost > 0 && price > 0 ? ((price - cost) / price) * 100 : 0,
      vendorSku: row.vendorSku || '',
    };
  });
};

export const buildStagesPayload = (
  stages,
  chargesMap,
  decorationMap,
  variants,
  stageFormData,
  customerName = '',
  subtotals = {},
  currencyCode = ''
) => {
  console.log('buildStagesPayload chargesMap:', chargesMap);
  console.log('decorationMap:', decorationMap);
  // const defaultLineItemId = Array.isArray(variants) && variants.length > 0 ? variants[0].id : null;
  const allKeys = [0, ...(Array.isArray(stages) ? stages.map(s => s.id) : [])];

  const buildEntry = (key, seq, formData = {}, toLocation = '') => {
    const variantsTotal = key === 0
      ? (variants || []).reduce((sum, row) => {
          const extSell = row?.extSell != null
            ? Number(row.extSell)
            : Number(row?.price || 0) * Number(row?.quantity || 0);
          return sum + (Number.isFinite(extSell) ? extSell : 0);
        }, 0)
      : 0;
    const chargesTotal = (chargesMap?.[key] || []).reduce(
      (sum, charge) => sum + (Number.parseFloat(charge?.extSell) || 0),
      0,
    );
    const decorationsTotal = (decorationMap?.[key] || []).reduce(
      (sum, decoration) => sum + getDecorationExtSellValue(decoration, variants),
      0,
    );
    const subtotal = variantsTotal + chargesTotal + decorationsTotal;
    const formattedSubtotal = currencyCode
      ? formattedAmount(subtotal, currencyCode)
      : formData.formatted_subtotal || `${subtotal.toFixed(2)}`;
    return ({
    ...(formData.id ? { id: formData.id } : {}),
    seq,
    vendorId: formData.vendor_id ?? formData.vendorId ?? null,
    vendorName: formData.vendor_name || '',
    shipMethod: formData.ship_method || '',
    shipMethodId: formData.ship_method_id ?? null,
    carrierId: formData.carrier_id ?? null,
    shippingAccountId: formData.shipping_account_id ?? null,
    comments: formData.comments || '',
    fromLocation: formData.vendor_name || '',
    toLocation,
    subtotal,
    formattedSubtotal,
    charges: (chargesMap?.[key] || []).filter(c => true).map(c => {
      return {
      // ...(c.id ? { id: c.id } : {}),
      id: c.id,
      name: c.name,
      quantity: c.quantity,
      hideCost: !!c.hideCost,
      hidePrice: !!c.hideSell,
      unitCost: c.unitCost,
      unitSell: c.unitSell,
      extCost: c.extCost,
      extSell: c.extSell,
      lineItemId: c.lineItemId,
    }}),
    decorations: (decorationMap?.[key] || []).map(d => {
      // Build variant as array of key-value objects matching the selected line item rows
      const reservedKeys = new Set(['id', 'tempId', 'quantity', 'cost', 'price', 'margin', 'extSell', 'imageUrl', 'skuLabel', 'skuId', 'description', 'vendorSku']);
      const selectedVariantIds = new Set((d.variant || []).map((v) => String(v.id ?? v.tempId)));
      const variantPayload = (variants || [])
        .filter((row) => selectedVariantIds.has(String(row.id ?? row.tempId)))
        .map((row) => Object.fromEntries(
          Object.entries(row).filter(([k, v]) => !reservedKeys.has(k) && v !== null && v !== undefined && v !== '')
        ));
      return ({
        id: d.id,
        name: d.name,
        position: d.position,
        imprint: d.imprintType,
        variant: variantPayload,
        cost: d.cost,
        price: d.price,
        quantity: d.quantity,
        extSell: getDecorationExtSellValue(d, variants),
        hideCost: !!d.hideCost,
        hidePrice: !!d.hideSell,
        images: d.images || [],
        lineItemId: d.lineItemId,
        stageId: formData.id,
      });
    }),
  })};

  // toLocation = next stage's vendor_name, or customer name for the last stage
  return allKeys.map((key, i) => {
    const nextKey = allKeys[i + 1];
    const toLocation = nextKey !== undefined
      ? (stageFormData?.[nextKey]?.vendor_name || '')
      : customerName;
    return buildEntry(key, i, stageFormData?.[key] || {}, toLocation);
  });
};
